import Link from 'next/link'
import { z } from 'zod'

import Button from '@nxt-insurance/ui-kit/components/Button'

import { horizontalAlignmentEnum } from '@/cms/helperTypes'
import { BUTTONS_IDS, EVENTS } from '@/constants/analytics'
import { useAnalytics } from '@/context/AnalyticsContext'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

const horizontalAlignmentToFlex = {
  center: 'center',
  left: 'flex-start',
  right: 'flex-end',
} as const

const ctaButton = z.object({
  _type: z.literal('ctaButton'),
  align: horizontalAlignmentEnum.optional(),
  title: z.string(),
  url: z.string(),
})

export const CtaButton = (props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = ctaButton.parse(props.node.value)
  const { track } = useAnalytics()
  return (
    <Link
      className="inline-flex"
      href={value.url}
      passHref
      style={{ alignSelf: horizontalAlignmentToFlex[value.align ?? 'left'] }}
    >
      <Button
        label={value.title}
        onPress={() => {
          track(EVENTS.ButtonClicked, {
            buttonId: BUTTONS_IDS.BUTTON_FROM_SANITY_CONTENT,
            type: 'link',
            href: value.url,
          })
        }}
      />
    </Link>
  )
}
